// import DataService, { PublicService } from "../utils/service";
// import { StoreProvider } from "../utils/store.provider";
import { useAccountStore } from "base/stores";
import { DataService, PublicService } from "base/services";

import { usePickerDetailsStore } from "../libs/stores/filepicker";
import { sentryCaptureException } from "../components/primitives/errorboundary";

// let actionPath = null;

export const UploadService = {
  getResumableURI(fileData) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/upload/2/${accountId}/resumable`, {
      data: fileData
    });
  },
  putChunk(url, options) {
    return DataService.upload(url, {
      method: "PUT",
      headers: options.headers || {},
      body: options.data
    });
  },
  async initUpload(url, fileData) {
    const accountId = useAccountStore.getState()._id;
    let actionPath = usePickerDetailsStore.getState().actionPath;
    if (actionPath) {
      const [postData] = PublicService.post(`${actionPath}/MultiPartInit`, {
        data: fileData,
        options: {
          recaptcha_action: "multipartinit"
        }
      });
      return await postData();
    } else {
      const [postData] = DataService.post(`/upload/2/${accountId}/init`, {
        data: fileData
      });
      return await postData();
    }
  },
  initProfileUpload(userId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/upload/2/${accountId}/init/profile`, {
      data: { UserId: userId }
    });
  },
  async getSignedUrl(fileData, uploadURL) {
    let accountId = useAccountStore.getState()._id;
    // Note: Raising sentryerror if there is no accountId is present in store.
    if (!accountId) {
      sentryCaptureException(accountId, "accountId is not Present in store");
      accountId = window.accountDetails._id;
    }

    let actionPath = usePickerDetailsStore.getState().actionPath;
    let url = uploadURL || `/upload/2/${accountId}/`;
    if (actionPath) {
      const [postData] = PublicService.post(`${actionPath}/SinglePart`, {
        data: fileData,
        options: {
          recaptcha_action: "singlepart"
        }
      });
      return await postData();
    } else {
      const [postData] = DataService.post(url, {
        data: fileData
      });
      return await postData();
    }
  },
  uploadPart(url, options) {
    return DataService.upload(url, {
      method: "PUT",
      headers: options.headers || {},
      body: options.data
    });
  },
  uploadToDrive(driveId, data) {
    const accountId = useAccountStore.getState()._id;
    return DataService.update(`/upload/2/${accountId}/${driveId}/`, {
      data: data
    });
  },
  async completeUpload(data) {
    const accountId = useAccountStore.getState()._id;
    let actionPath = usePickerDetailsStore.getState().actionPath;
    if (actionPath) {
      const [postData] = PublicService.post(`${actionPath}/MultiPartComplete`, {
        data: data,
        options: {
          recaptcha_action: "multipartcomplete"
        }
      });
      return await postData();
    } else {
      const [postData] = DataService.post(`/upload/2/${accountId}/complete`, {
        data: data
      });
      return await postData();
    }
  },
  getFolders(data) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/upload/2/${accountId}/${data.driveId}/folders`, {
      query: { q: data.q || "", parent: data.parent || "" }
    });
  },
  generateThumbnail(data) {
    const accountId = useAccountStore.getState()._id;
    let actionPath = usePickerDetailsStore.getState().actionPath;
    if (actionPath) {
      return PublicService.update(`${actionPath}/GenerateThumbnail`, {
        data: data,
        options: {
          recaptcha_action: "generatethumbnail"
        }
      });
    }
    return DataService.update(`/upload/2/${accountId}/image/thumbnail`, {
      data: data
    });
  },
  async getInitConfig() {
    const accountId = useAccountStore.getState()._id;
    let actionPath = usePickerDetailsStore.getState().actionPath;
    console.info("picker details", actionPath);
    if (actionPath) {
      const [init] = PublicService.get(`${actionPath}/InitFilePicker`, {
        options: {
          recaptcha_action: "initfilepicker"
        }
      });
      return await init();
    } else {
      const [init] = DataService.get(`/upload/2/${accountId}/init`);
      return await init();
    }
  },
  async uploadToS3(url, driveId, data) {
    url = url.concat(driveId);
    const [uploadToS3] = DataService.post(url, {
      data: data
    });
    return await uploadToS3();
  },
  getUploadStatus(uploadId) {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/upload/2/${accountId}/status?Id=${uploadId}`);
  },
  async getNewDriveToken(driveId) {
    const accountId = useAccountStore.getState()._id;
    const [getToken] = DataService.get(
      `/upload/2/${accountId}/${driveId}/token`
    );
    return await getToken();
  },
  async drvieSignOut(driveId) {
    const accountId = useAccountStore.getState()._id;
    const [signOut] = DataService.get(
      `/upload/2/${accountId}/${driveId}/logout`
    );
    return await signOut();
  },
  async getFileFromBox(accountId, parent) {
    const [getFiles] = DataService.get(
      `/upload/2/${accountId}/box/files/${parent}`
    );
    return await getFiles();
  },
  getSearchFilesFromBox(accountId, q) {
    return DataService.get(`/upload/2/${accountId}/box/search?q=${q}`);
  },
  uploadImageUrl(data, toast = true) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/upload/2/${accountId}/web/`, {
      data: data,
      toast
    });
  }
};
